import { render, staticRenderFns } from "./SideBarAdmin.vue?vue&type=template&id=328da476"
import script from "./SideBarAdmin.vue?vue&type=script&lang=js"
export * from "./SideBarAdmin.vue?vue&type=script&lang=js"
import style0 from "./SideBarAdmin.vue?vue&type=style&index=0&id=328da476&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports